import CardBorderImage from "../assets/border.png";

import nameCostLine from "./manaCostMaker";
import oracleBuilder from "./oracleBuilder";
import ptBuilder from "./ptBuilder";
import walkerBuilder from "./walkerBuilder";
import loyaltyBuilder from "./loyaltyBuilder";
import defenceBuilder from "./defenceBuilder";
import artBuilder from "./artBuilder";
import backgrounds from "./backgrounds";

const DEBUG = false;

//const borderWidth = 35;
const imgHeight = 1107;
const imgWidth = 791;
const pannelWidth = 715;
const pannelHeight = 495;

const borderWidth = Math.round((imgWidth - pannelWidth) / 2);
const bottomOffset = Math.round(imgHeight - (pannelHeight + borderWidth));

const topPositions = {
	borderX: borderWidth,
	borderY: borderWidth,
	nameX: 30,
	nameY: 30,
	typeX: 35,
	typeY: 135,
	oracleX: 40,
	walkerOracleX: 3,
	oracleY: 165,
	ptX: 577,
	ptY: 478,
	loyaltyX: 610,
	loyaltyY: 485,
	defenceX: 650,
	defenceY: 470,
	artistX: 60,
	artistY: 560,
};
const bottomPositions = {
	borderX: borderWidth,
	borderY: bottomOffset,
	ptX: 575,
	ptY: 438 + bottomOffset,
	loyaltyX: 630,
	loyaltyY: 448 + bottomOffset,
	artistX: 60,
	artistY: 518 + bottomOffset,
};

const fontSizes = {
	cardName: "33px Beleren",
	cardType: "33px Beleren",
	smallTypeLine : "28px Beleren",
	cardPT: "45px Beleren",
	cardOracle: "33px MPlatin",
	walkerOracle: "29px MPlatin",
	walkerCost: "27px Beleren",
	artistName: "15px Beleren",
};

const cardBuilder = (props) => {
	debugLog(props);
	if (Object.keys(props.backFace).length === 0) {
		debugLog("Cardbuilder : no backface");
		return new Promise((res, rej) => {
			res();
		});
	}
	const cardCanvas = document.createElement("canvas");
	const ctx = cardCanvas.getContext("2d");
	cardCanvas.width = 791;
	cardCanvas.height = 1107;
	ctx.clearRect(0, 0, cardCanvas.width, cardCanvas.height);
	return new Promise((resolve, reject) => {
		const img = document.createElement("img");
		img.src = CardBorderImage;
		img.onload = () => resolve(img);
	})
		.then((img) => {
			if(props.addBleedBorder){
				ctx.fillStyle = "#000000";
				ctx.fillRect(0,0,props.width,props.height);
			}else{
				ctx.drawImage(img, 0, 0);
			}
			return drawCardHalf(true, props.frontFace, props.drawTop);
		})
		.then((top) => {
			return new Promise((res, rej) => {
				const topImg = document.createElement("img");
				topImg.src = top;
				topImg.onload = () => {
					debugLog("top image loaded");
					ctx.drawImage(topImg, topPositions.borderX, topPositions.borderY);
					res(drawCardHalf(false, props.backFace, props.drawBottom));
				};
			})
				.then((bottom) => {
					return new Promise((res, rej) => {
						const bottomImg = document.createElement("img");
						bottomImg.src = bottom;
						bottomImg.onload = () => {
							debugLog("bottom image loaded");
							ctx.drawImage(
								bottomImg,
								bottomPositions.borderX,
								bottomPositions.borderY
							);
							res();
						};
					});
				})
				.then(() => {
					// check if we need to draw top PT or loyaltly.
					// these exist outside of the frame so need to be done here
					const cardType =
						props.frontFace.type_line !== undefined
							? props.frontFace.type_line
							: "";
					if (cardType.indexOf("Planeswalker") > -1) {
						debugLog(`Top half is a walker`);
						if (props.frontFace.loyalty !== undefined) {
							return loyaltyBuilder(props.frontFace.loyalty, fontSizes.cardPT);
						} else {
							return;
						}
					} else if (
						cardType.indexOf("eature") > -1 ||
						cardType.indexOf("echicle") > -1
					) {
						debugLog(`Top half is a creature or vehicle`);
						const power =
							props.frontFace.power !== undefined ? props.frontFace.power : "";
						const toughness =
							props.frontFace.toughness !== undefined
								? props.frontFace.toughness
								: "";
						return ptBuilder(
							power,
							toughness,
							fontSizes.cardPT,
							props.frontFace.colors
						);
					} else if (cardType.indexOf("Battle") > -1) {
						debugLog("Building a battle");
						return defenceBuilder(props.frontFace.defense, fontSizes.cardPT);
					} else {
						debugLog(`top half doesn't need pt/loyalty/defence because its a '${cardType}'`);

						return;
					}
				})
				.then((TBRsrc) => {
					// top bottom right bit
					if (TBRsrc !== undefined) {
						return new Promise((res, rej) => {
							const TBRimg = document.createElement("img");
							TBRimg.src = TBRsrc;
							const cardType =
								props.frontFace.type_line !== undefined
									? props.frontFace.type_line
									: "";
							TBRimg.onload = () => {
								if (cardType.indexOf("Planeswalker") > -1) {

									ctx.drawImage(
										TBRimg,
										topPositions.loyaltyX,
										topPositions.loyaltyY
									);
								} else if (cardType.indexOf("Battle") > -1) {
									ctx.drawImage(
										TBRimg,
										topPositions.defenceX,
										topPositions.defenceY
									);
								} else {
									ctx.drawImage(TBRimg, topPositions.ptX, topPositions.ptY);
								}
								const backType =
									props.backFace.type_line !== undefined
										? props.backFace.type_line
										: "";
								if (backType.indexOf("Planeswalker") > -1) {
									debugLog(`Bottom half is a walker`)
									if (props.backFace.loyalty !== undefined) {
										res(
											loyaltyBuilder(props.backFace.loyalty, fontSizes.cardPT)
										);
									}
								} else if (
									backType.indexOf("eature") > -1 ||
									backType.indexOf("ehicle") > -1
								) {
									debugLog(`Bottom half is a creature or vehicle`);
									const power =
										props.backFace.power !== undefined
											? props.backFace.power
											: "";
									const toughness =
										props.backFace.toughness !== undefined
											? props.backFace.toughness
											: "";
									res(
										ptBuilder(
											power,
											toughness,
											fontSizes.cardPT,
											props.backFace.colors
										)
									);
								}
								res();
							};
						});
					} else {
						const cardType =
							props.backFace.type_line !== undefined
								? props.backFace.type_line
								: "";
						if (cardType.indexOf("Planeswalker") > -1) {
							if (props.backFace.loyalty !== undefined) {
								return loyaltyBuilder(props.backFace.loyalty, fontSizes.cardPT);
							} else {
								return;
							}
						} else if (
							cardType.indexOf("eature") > -1 ||
							cardType.indexOf("ehicle") > -1
						) {
							const power =
								props.backFace.power !== undefined ? props.backFace.power : "";
							const toughness =
								props.backFace.toughness !== undefined
									? props.backFace.toughness
									: "";
							return ptBuilder(
								power,
								toughness,
								fontSizes.cardPT,
								props.backFace.colors
							);
						} else {
							return;
						}
					}
				})
				.then((BBRsrc) => {
					// bottom bottom right bit
					if (BBRsrc === undefined) {
						return;
					} else {
						return new Promise((res, rej) => {
							const BBRimg = document.createElement("img");
							BBRimg.src = BBRsrc;
							BBRimg.onload = () => {
								const cardType =
									props.backFace.type_line !== undefined
										? props.backFace.type_line
										: "";
								if (cardType.indexOf("Planeswalker") > -1) {
									ctx.drawImage(
										BBRimg,
										bottomPositions.loyaltyX,
										bottomPositions.loyaltyY
									);
								} else {
									ctx.drawImage(
										BBRimg,
										bottomPositions.ptX,
										bottomPositions.ptY
									);
								}
								res();
							};
						});
					}
				})
				.then(() => {
					// draw the artists
					ctx.fillStyle = "white";
					ctx.font = fontSizes.artistName;
					ctx.fillText(
						`Artist : ${props.backFace.artist} © Wizards of the Coast NOT FOR SALE`,
						bottomPositions.artistX,
						bottomPositions.artistY
					);
				})
				.then(() => {
					return new Promise((res, rej) => {
						res(cardCanvas.toDataURL("image/png"));
					});
				});
		});
};

const drawCardHalf = (isTop, cardData, drawArt) => {
	debugLog("drawCardHalf");
	const pos = topPositions;
	const canvas = document.createElement("canvas");
	canvas.width = pannelWidth;
	canvas.height = pannelHeight;
	const ctx = canvas.getContext("2d");

	const cardType = cardData.type_line !== undefined ? cardData.type_line : "";

	return new Promise((resolve, reject) => {
		const img = document.createElement("img");
		debugLog("drawCardHalf : getting card frame");
		const cardType = getCardFrame(
			cardData.colors,
			cardData.type_line,
			cardData.oracle_text
		);
		debugLog(`drawCardHalf - card frame: ${JSON.stringify(cardType)}`);
		img.src = cardType.frame;
		if (cardType.background !== false) {
			// draw the fade.
			const grd = ctx.createLinearGradient(0, 0, canvas.width - 5, 0);
			grd.addColorStop(0, backgrounds.gradientColours[cardType.background[0]]);
			grd.addColorStop(1, backgrounds.gradientColours[cardType.background[1]]);
			ctx.fillStyle = grd;
			ctx.fillRect(0, 0, canvas.width - 5, canvas.height);
			ctx.fillStyle = "black";
		}
		img.onload = () => resolve(img);
	})
		.then((bgImg) => {
			debugLog(`drawing text`);
			ctx.drawImage(bgImg, 0, 0);
			ctx.font = fontSizes.cardName;
			// draw the type line
			// check if we need to make the font a bit smaller because its too long
			if(cardData.type_line.length >= 40){
				ctx.font = fontSizes.smallTypeLine;
			}
			ctx.fillText(
				cardData.type_line ? cardData.type_line : "",
				pos.typeX,
				pos.typeY
			);
			ctx.font = fontSizes.cardName;
			// do the mana cost
			const name = cardData.name ? cardData.name : "";
			const cost = cardData.mana_cost ? cardData.mana_cost : "";
			return nameCostLine(name, fontSizes.cardName, cost, 650, 45);
		})
		.then((nameCostImg) => {
			return new Promise((res, rej) => {
				const costImg = document.createElement("img");
				costImg.src = nameCostImg;
				costImg.onload = () => {
					ctx.drawImage(costImg, pos.nameX, pos.nameY);
					res(artBuilder(cardData.image_uris, cardData.type_line));
				};
			});
		})
		.then((artImg) => {
			return new Promise((res, rej) => {
				const bgArt = document.createElement("img");
				bgArt.src = artImg;
				bgArt.onload = () => {
					if (drawArt) {
						ctx.drawImage(bgArt, 0, 0);
					}
					const oracleText = cardData.oracle_text ? cardData.oracle_text : "";
					if (cardType.indexOf("Planeswalker") > -1) {
						// do walker stuff
						res(
							walkerBuilder(
								oracleText,
								fontSizes.walkerOracle,
								fontSizes.walkerCost,
								680,
								320
							)
						);
					} else {
						// do non walker stuff
						const oracleFont = oracleText.length > 500 ? fontSizes.walkerOracle : fontSizes.cardOracle;
						const isLong = oracleText.length > 500 ? true : false;
						res(oracleBuilder(oracleText, oracleFont, 640, 320, isLong));
					}
				};
			});
		})
		.then((oracleImgSrc) => {
			return new Promise((res, rej) => {
				const oracleImg = document.createElement("img");
				oracleImg.src = oracleImgSrc;
				oracleImg.onload = () => {
					if (cardType.indexOf("Planeswalker") > -1) {
						ctx.drawImage(oracleImg, pos.walkerOracleX, pos.oracleY);
					} else {
						ctx.drawImage(oracleImg, pos.oracleX, pos.oracleY);
					}
					res();
				};
			});
		})
		.then((brImgSrc) => {
			if (brImgSrc === undefined) {
				return;
			} else {
				return new Promise((res, rej) => {
					const brImg = document.createElement("img");
					brImg.src = brImgSrc;
					brImg.onload = () => {
						if (cardType.indexOf("Planeswalker") > -1) {
							ctx.drawImage(brImg, pos.loyaltyX, pos.loyaltyY);
						} else {
							ctx.drawImage(brImg, pos.ptX, pos.ptY);
						}
						res();
					};
				});
			}
		})
		.then(() => {
			return new Promise((res, rej) => {
				res(canvas.toDataURL("image/png"));
			});
		})
		.catch(e=> {
			console.error(e);
		})
};

function getCardFrame(colours, type, oracle) {
	const cardFrame = {
		frame: backgrounds.Artifact,
		background: false,
	};
	if (type.indexOf("Land") > -1) {
		// TODO check for "any colour"
		// do land stuff
		const regex = /{[WUBRGC]}/g;
		const landColours = [...oracle.matchAll(regex)];
		debugLog(landColours);
		if (oracle.indexOf("any color") > -1) {
			debugLog(`Land any colour`)
			cardFrame.frame = backgrounds.GoldLand;
		} else if (landColours.length === 1) {
			debugLog(`land singleColour : ${landColours[0]}`);
			cardFrame.frame = backgrounds.colouredLands[landColours[0]];
		} else if (landColours.length === 2) {
			debugLog(`Dual land ${landColours.toString()}`);
			cardFrame.frame = backgrounds.DualLand;
			cardFrame.background = landColours;
		} else if (landColours.length > 2) {
			debugLog(`Multi land`);
			cardFrame.frame = backgrounds.GoldLand;
		} else {
			debugLog(`Defulat land `);
			cardFrame.frame = backgrounds.colouredLands["{C}"];
		}
		debugLog(`Card is land and the frame is :${JSON.stringify(cardFrame)}`);
	} else if (type.indexOf("Artifact") === -1) {
		if (colours.length === 1) {
			cardFrame.frame = backgrounds.colourPannels[colours[0]];
		} else if (colours.length === 2) {
			cardFrame.frame = backgrounds.DualGold;
			cardFrame.background = colours.map((c) => `{${c}}`);
		} else if (colours.length > 2) {
			cardFrame.frame = backgrounds.colourPannels["M"];
		} else {
			cardFrame.frame = backgrounds.Artifact;
		}
	}
	debugLog(`getCardFrame : ${JSON.stringify(cardFrame)} : : ${colours} ${type} ${oracle}`);
	return cardFrame;
}

function debugLog(text) {
	if (DEBUG) {
		console.log(text);
	}
}

export default cardBuilder;
